import "./styles.css";
import "./puzzle/styles.css";
import "./admin/admin.css";
import { UnifiedAdminApp } from "./admin/UnifiedAdminApp";
import { PuzzleAppController } from "./puzzle/PuzzleAppController";
import { FoamArenaApp } from "./ui/FoamArenaApp";

const root = document.querySelector<HTMLElement>("#app");
if (!root) throw new Error("#app mount point is missing");

const path = location.pathname;
const app = path === "/admin" || path.startsWith("/admin/")
  ? new UnifiedAdminApp(root)
  : path === "/arena" || path.startsWith("/arena/")
    ? new FoamArenaApp(root)
    : new PuzzleAppController(root);

document.title = path.startsWith("/admin")
  ? "Live Match Control · Foam Lab"
  : path.startsWith("/arena")
    ? "Foam Arena"
    : "Foam Pop";

app.mount();
